import Swiper, { Pagination } from 'swiper';
import { bulletRenderer } from './utilFunctions';

const swiperSelector = '.product-information-swiper';

export default () => {
	const data = {
		cache: {
			imageSrcs: [],
		},
		init() {
			document
				.querySelectorAll(
					swiperSelector +
						' .swiper-wrapper .swiper-slide img, .swiper-wrapper .swiper-slide iframe'
				)
				.forEach((e, i) => {
					if (!data.cache.imageSrcs[i]) {
						data.cache.imageSrcs[i] = {};
					}
					data.cache.imageSrcs[i].href = e.src;
					data.cache.imageSrcs[i].thumb = e.dataset.thumb || null;
				});
			data.swiperObj.init();
		},
		swiperObj: null,
		swiperProps: {
			['@click']() {},
		},
	};

	data.swiperObj = new Swiper(swiperSelector, {
		modules: [Pagination],
		allowTouchMove: false,
		init: false,

		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			renderBullet: bulletRenderer(data.cache.imageSrcs),
		},
	});

	return data;
};
